import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ReducedProfile } from '@interfaces/profiles/reduced-profile';
import { AuthService } from '@services/auth.service';
import { ProfileService } from '@services/profile.service';
import { UiService } from '@services/ui.service';
import { tap } from 'rxjs';

export const ProfileSelectorResolver: ResolveFn<ReducedProfile[]> = (
	route,
	state,
	profileSrv = inject(ProfileService),
    uiSrv = inject(UiService),
    authSrv = inject(AuthService)
) => {
	return profileSrv.getUserProfiles()
        .pipe(
            tap({
                next: (result: ReducedProfile[]) => {
                     uiSrv.routeLoadingStateChanged.next(false);
                },
                error: () => uiSrv.routeLoadingStateChanged.next(false)
            })
        );
};
